import React, { Component } from 'react';
import { styled } from '@mui/system';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '../../components/Checkbox.js';
import Text from '../../components/Text.js';
import Modal from './Modal.js';
import * as Theme from '../../theme/index.js';
import * as session from '../../services/session.js';
import { lsaOptions } from '../../services/constants.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
const FullScreenBlock = styled("div")(({
  theme
}) => ({
  display: 'block',
  [theme.breakpoints.down(750)]: {
    display: 'none'
  }
}));
const MobileColumn = styled("div")(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.down(750)]: {
    display: 'block',
    width: '100%'
  }
}));

/**
 * @param classes
 * @returns {*}
 * @constructor
 */
class LsaSelectionModal extends Component {
  state = {
    selectedItems: null
  };
  async componentDidMount() {
    let selectedItems = this.props.items || (await this.props.getItems());

    // if the items are not already categorized then categorize them
    if (!selectedItems || !selectedItems.Health) {
      selectedItems = await this._categorizeItems(selectedItems);
    }
    this.setState({
      selectedItems
    });
    if (this.props.isMasterApp) {
      setInterval(async () => {
        await session.saveLsaOptions(this.state.selectedItems);
      }, 30000);
    }
  }
  _categorizeItems = async items => {
    const data = {
      Health: [],
      Alternative: [],
      Cosmetic: [],
      Personal: [],
      FitnessAndSports: [],
      Other: []
    };
    if (!items) {
      return data;
    }

    // eslint-disable-next-line array-callback-return
    const promises = items.map(item => {
      if (lsaOptions.Health.includes(item)) {
        data.Health.push(item);
      } else if (lsaOptions.Alternative.includes(item)) {
        data.Alternative.push(item);
      } else if (lsaOptions.Cosmetic.includes(item)) {
        data.Cosmetic.push(item);
      } else if (lsaOptions.Personal.includes(item)) {
        data.Personal.push(item);
      } else if (lsaOptions.FitnessAndSports.includes(item)) {
        data.FitnessAndSports.push(item);
      } else {
        data.Other.push(item);
      }
    });
    await Promise.all(promises);
    return data;
  };
  _selectLsaItem = (parent, item) => {
    const selectedItems = this.state.selectedItems;
    if (!item) {
      if (!selectedItems[parent].length) {
        this.setState({
          selectedItems: {
            ...selectedItems,
            [parent]: lsaOptions[parent]
          }
        });
      } else {
        this.setState({
          selectedItems: {
            ...selectedItems,
            [parent]: []
          }
        });
      }
    } else {
      let unique = !selectedItems[parent].includes(item);
      this.setState({
        selectedItems: {
          ...selectedItems,
          [parent]: unique ? [item, ...selectedItems[parent]] : [...selectedItems[parent].filter(x => x !== item)]
        }
      });
    }
  };
  _onSave = async () => {
    const selectedItems = this.state.selectedItems;
    const lsaItems = [];
    Object.keys(selectedItems).map(key => lsaItems.push(selectedItems[key]));
    const items = lsaItems.flat();
    if (!items.length) {
      alert(i18n.t(tokens.labels.validation.oneChoice));
      return false;
    }
    const success = await this.props.onSave(items);
    if (success) {
      this._onClose();
    }
    return true;
  };
  _onClose = async () => {
    if (this.props.isMasterApp) {
      await session.saveLsaOptions(this.state.selectedItems);
    }
    this.props.close();
    return true;
  };
  render() {
    const {
      open
    } = this.props;
    const {
      selectedItems
    } = this.state;
    if (!this.state.selectedItems) {
      return null;
    }
    const styles = {
      lsaOptionsTitleRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${Theme.colors.lightGrey}`,
        marginTop: 20
      },
      lsaColumn: {
        width: '34%'
      },
      lsaOptionRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 20
      },
      lsaColumnMobileTitle: {
        width: '100%',
        borderBottom: `1px solid ${Theme.colors.lightGrey}`,
        marginTop: 20
      },
      lsaColumnMobile: {
        width: '100%',
        marginBottom: 20
      }
    };
    return /*#__PURE__*/React.createElement(Modal, {
      large: true,
      title: i18n.t(tokens.labels.spendingAccounts.lifestyleSpendingAccount),
      open: open,
      onClose: this._onClose,
      onBack: this._onClose,
      loader: this.props.loading,
      primaryButton: {
        label: i18n.t(tokens.buttons.save),
        onClick: this._onSave
      }
    }, /*#__PURE__*/React.createElement(Text, null, i18n.t(tokens.labels.masterApplication.lifestyleSpendingAccount)), /*#__PURE__*/React.createElement(FullScreenBlock, null, /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionsTitleRow
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      sx: styles.lsaColumn,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: Boolean(selectedItems.Health?.length),
        onChange: () => this._selectLsaItem('Health', ''),
        value: "Health",
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        bold: true
      }, i18n.t(tokens.labels.health))
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      sx: styles.lsaColumn,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: Boolean(selectedItems.Alternative?.length),
        onChange: () => this._selectLsaItem("Alternative", ''),
        value: "Alternative",
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        bold: true
      }, i18n.t(tokens.labels.lsaModal.alternativePractitioner))
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      sx: styles.lsaColumn,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: Boolean(selectedItems.Cosmetic?.length),
        onChange: () => this._selectLsaItem("Cosmetic", ''),
        value: "Cosmetic",
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        bold: true
      }, i18n.t(tokens.labels.lsaModal.cosmetic))
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionRow
    }, /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Health.map(item => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: item,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: selectedItems.Health.includes(item),
        onChange: () => this._selectLsaItem("Health", item),
        value: item,
        color: "secondary"
      }),
      label: localizationMaps.fromEnglish("benefits", item)
    }))), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Alternative.map(item => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: item,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: selectedItems.Alternative.includes(item),
        onChange: () => this._selectLsaItem("Alternative", item),
        value: item,
        color: "secondary"
      }),
      label: localizationMaps.fromEnglish("benefits", item)
    }))), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Cosmetic.map(item => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: item,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: selectedItems.Cosmetic.includes(item),
        onChange: () => this._selectLsaItem("Cosmetic", item),
        value: item,
        color: "secondary"
      }),
      label: localizationMaps.fromEnglish("benefits", item)
    })))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionsTitleRow
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      sx: styles.lsaColumn,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: Boolean(selectedItems.Personal?.length),
        onChange: () => this._selectLsaItem('Personal', ''),
        value: "Personal",
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        bold: true
      }, i18n.t(tokens.labels.lsaModal.personal))
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      sx: styles.lsaColumn,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: Boolean(selectedItems.FitnessAndSports?.length),
        onChange: () => this._selectLsaItem("FitnessAndSports", ''),
        value: "FitnessAndSports",
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        bold: true
      }, i18n.t(tokens.labels.lsaModal.fitnessAndSports))
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      sx: styles.lsaColumn,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: Boolean(selectedItems.Other?.length),
        onChange: () => this._selectLsaItem("Other", ''),
        value: "Other",
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        bold: true
      }, i18n.t(tokens.labels.account.other))
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionRow
    }, /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Personal.map(item => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: item,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: selectedItems.Personal.includes(item),
        onChange: () => this._selectLsaItem("Personal", item),
        value: item,
        color: "secondary"
      }),
      label: localizationMaps.fromEnglish("benefits", item)
    }))), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.FitnessAndSports.map(item => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: item,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: selectedItems.FitnessAndSports.includes(item),
        onChange: () => this._selectLsaItem("FitnessAndSports", item),
        value: item,
        color: "secondary"
      }),
      label: localizationMaps.fromEnglish("benefits", item)
    }))), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Other.map(item => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: item,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: selectedItems.Other.includes(item),
        onChange: () => this._selectLsaItem("Other", item),
        value: item,
        color: "secondary"
      }),
      label: localizationMaps.fromEnglish("benefits", item)
    }))))), /*#__PURE__*/React.createElement(MobileColumn, null, Object.keys(lsaOptions).map(item => /*#__PURE__*/React.createElement("div", {
      key: item,
      style: styles.mobileSection
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      sx: styles.lsaColumnMobileTitle,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: Boolean(selectedItems[item]?.length),
        onChange: () => this._selectLsaItem(item, ''),
        value: item,
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        bold: true
      }, localizationMaps.fromEnglish("benefits", item))
    }), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumnMobile
    }, lsaOptions[item].map(subitem => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: subitem,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: selectedItems[item].includes(subitem),
        onChange: () => this._selectLsaItem(item, subitem),
        value: subitem,
        color: "secondary"
      }),
      label: localizationMaps.fromEnglish("benefits", item)
    })))))));
  }
}
export default LsaSelectionModal;